export default __webpack_public_path__ + "static/media/853.7faac622.gif";